import React, { useEffect, useState } from 'react';
import { FormGroup, Label } from 'reactstrap';
import { useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { post } from 'helpers/api_helper';
import { API_URL } from 'helpers/api_url';

async function fetchBuyerDeals(clientId) {
  try {
    const url = `ClientEngagement/allbyselectedtypesstatus`;

    const body = {
      clientId: parseInt(localStorage.getItem("userId")),
      agentId: parseInt(localStorage.getItem("agentId")),
      statusIds: [1],
      typeId: 1,
    };

    const response = await post(url, body);

    return response;
  } catch (error) {
    console.error("Error fetching buyer deals:", error);
    return [];
  }
}

const EngagementListBuyerClient = ({ name, clientId, agentId, typeId, statusId, selectedData }) => {
  const { values, errors, touched, setFieldValue, handleBlur } = useFormikContext();
  const [clientengagements, setEngagements] = useState([]);

  useEffect(() => {
    if (clientId && agentId) {
      fetchBuyerDeals(clientId).then((data) => {
        setEngagements(data);

        // ✅ Auto-select if only one engagement
        // if (data.length === 1) {
        //   setFieldValue(name, data[0].id);
        // }
      });
    }
  }, [clientId, agentId, name, setFieldValue]);

  const getType = (type) => type === 1 ? 'Rent' : type === 2 ? 'Purchase' : 'Unknown Type';
  const getSType = (type) => type === 1 ? 'Sell' : type === 2 ? 'Lease' : 'Unknown Type';

  const formatYYMM = (dateStr) => {
    if (!dateStr) return "0000";
    const date = new Date(dateStr);
    const yy = String(date.getFullYear()).slice(2);
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    return `${yy}${mm}`;
  };

  const fieldError = name.split('.').reduce((acc, key) => acc?.[key], errors);
  const fieldTouched = name.split('.').reduce((acc, key) => acc?.[key], touched);
  const fieldValue = name.split('.').reduce((acc, key) => acc?.[key], values);

  return (
    <FormGroup className="mb-3">
      <Label htmlFor={name}>Select deal *</Label>
      {/* <select
        name={name}
        className={`form-control ${fieldError && fieldTouched ? "is-invalid" : ""}`}
        onChange={(e) => setFieldValue(name, e.target.value)}
        onBlur={handleBlur}
        value={fieldValue || ""}
        disabled={selectedData} 
      >
        {clientengagements?.length === 0 && (
          <option value="">No deals found</option>
        )}

       
          <option value="">Select</option>
      

        {clientengagements?.map(option => {
          if (option.clientEngagementStatus === 3 && option.id !== Number(fieldValue)) {
            return null;
          }

          const label = option.isBuyer
            ? `${getType(option.buyerType)} - (${option.id} - ${formatYYMM(option.lastAgreementDate)})`
            : `${option.contactName} - ${getSType(option.sellerType)} - (${option.id} - ${formatYYMM(option.lastAgreementDate)})`;

          return (
            <option key={option.id} value={option.id}>
              {label}
            </option>
          );
        })}
      </select> */}
      <select
        name={name}
        className={`form-control ${fieldError && fieldTouched ? "is-invalid" : ""}`}
        onChange={(e) => {
          const selectedId = Number(e.target.value);
          setFieldValue(name, selectedId);

          const selectedOption = clientengagements.find(opt => opt.id === selectedId);

          if (selectedOption) {

            const basePath = name.split(".").slice(0, -1).join(".");

            if (selectedOption.isBuyer) {
              setFieldValue(`${basePath}.buyerType`, selectedOption.buyerType || "");
              setFieldValue(`${basePath}.sellerType`, "");
            } else if (selectedOption.isSeller) {
              setFieldValue(`${basePath}.sellerType`, selectedOption.sellerType || "");
              setFieldValue(`${basePath}.buyerType`, "");
            } else {
              setFieldValue(`${basePath}.buyerType`, "");
              setFieldValue(`${basePath}.sellerType`, "");
            }
          } else {
            const basePath = name.split(".").slice(0, -1).join(".");
            setFieldValue(`${basePath}.buyerType`, "");
            setFieldValue(`${basePath}.sellerType`, "");
          }
        }}
        onBlur={handleBlur}
        value={fieldValue || ""}
        disabled={selectedData}
      >
        {clientengagements?.length === 0 && <option value="">No deals found</option>}

        <option value="">Select</option>

        {clientengagements?.map(option => {
          if (option.clientEngagementStatus === 3 && option.id !== Number(fieldValue)) return null;

          const label = option.isBuyer
            ? `${getType(option.buyerType)} - (${option.id} - ${formatYYMM(option.lastAgreementDate)})`
            : `${option.contactName} - ${getSType(option.sellerType)} - (${option.id} - ${formatYYMM(option.lastAgreementDate)})`;

          return (
            <option key={option.id} value={option.id}>
              {label}
            </option>
          );
        })}
      </select>

      {fieldError && fieldTouched && (
        <div className="invalid-feedback">{fieldError}</div>
      )}
    </FormGroup>
  );
};

EngagementListBuyerClient.propTypes = {
  name: PropTypes.string.isRequired,
  clientId: PropTypes.string.isRequired,
  agentId: PropTypes.string.isRequired,
  typeId: PropTypes.number,
  statusId: PropTypes.number,
  selectedData: PropTypes.number
};

export default EngagementListBuyerClient;
